import React from "react";
import _ from "lodash";

import SingleWinner from "../components/SingleWinner";
import MultipleWinners from "../components/MultipleWinners";
import NoSubmission from "../components/NoSubmission";

const Over = ({ users, photo, captions, player, over_params, currentPlayer }) => {
  let votes = _.map(player, "vote");
  let vote_array = [...Array(users.length).keys()].fill(0);
  votes.forEach((vote) => {
    vote_array[vote]++;
  });
  const m = Math.max(...vote_array);
  const max_indexes = vote_array.reduce((p, c, i, a) => (c === m ? p.concat(i) : p), []);
  let most_voted_captions = captions.filter(
    (_, index) => max_indexes.find((item) => item === index) !== undefined,
  );
  const winner_users = users.filter(
    (user) => most_voted_captions.find((item) => item.player_id === user.player_id) !== undefined,
  );
  let winning_captions = most_voted_captions.map((item) => ({
    ...item,
    display_name: winner_users.find((user) => user.player_id === item.player_id).display_name,
  }));
  const count = player.filter((item) => item.vote === max_indexes[0]).length;
  const percentage = Math.round((count / player.length) * 100);

  const get_component = () => {
    return _.isEmpty(player) ? (
      <NoSubmission photo={photo} over_params={over_params} no_captions={_.isEmpty(captions)} />
    ) : winning_captions.length === 1 ? (
      <SingleWinner
        photo={photo}
        percentage={percentage}
        over_params={over_params}
        caption={winning_captions[0].caption}
        winnerName={winning_captions[0].display_name}
        userWon={currentPlayer.player_id === winning_captions[0].player_id}
      />
    ) : (
      <MultipleWinners
        photo={photo}
        percentage={percentage}
        over_params={over_params}
        currentPlayer={currentPlayer}
        winning_captions={winning_captions}
      />
    );
  };
  return get_component();
};

export default Over;
